import web from "../src/images/s1.jpg";
import app from "../src/images/app.jpeg";
import android from "../src/images/android.jpeg";
import digital from "../src/images/digital.jpeg";
import marketing from "../src/images/marketing.jpg";
import software from "../src/images/software.jpeg";

const Sdata = [
  {
    imgsrc: web,
    title: "web development",
  },
  {
    imgsrc: app,
    title: "App development",
  },
  {
    imgsrc: software,
    title: "Software development",
  },
  {
    imgsrc: digital,
    title: "Digital Marketing",
  },
  {
    imgsrc: android,
    title: "Android development",
  },
  {
    imgsrc: marketing,
    title: "Marketing",
  },
];

export default Sdata;
